import { PRESETS, type PresetName } from '../../core';

export const PRESET_NAMES = Object.keys(PRESETS) as PresetName[];

/** Human-readable preset names, shared by the QC and Batch preset selects. */
export const PRESET_LABELS: Record<PresetName, string> = {
  generic: 'Generic',
  'netflix-latin': 'Netflix (Latin)',
  youtube: 'YouTube',
  'netflix-arabic': 'Netflix (Arabic)',
};

/**
 * A built-in preset's picker label with a Verified/Draft suffix (cue-forge-drt.9),
 * so the compliance standing — the moat vs tools with undocumented defaults — is
 * visible at the point of choice, not only in the collapsed threshold sheet.
 * Custom presets aren't decorated here: they sit under a separate "Custom"
 * optgroup and are always Draft by construction.
 */
export function presetOptionLabel(name: PresetName): string {
  return `${PRESET_LABELS[name]} — ${PRESETS[name].verified ? 'Verified' : 'Draft'}`;
}

const BUILTIN_NAME_SET = new Set(
  [...PRESET_NAMES, ...Object.values(PRESET_LABELS)].map((s) => s.toLowerCase()),
);

/**
 * Whether a name exactly reuses a built-in preset's id or label (case-insensitive,
 * trimmed). A custom preset may never carry one (product decision, 3r9 spec §8):
 * a "Netflix (Latin)" custom would spoof the verified preset in the QC/Batch
 * pickers and the report header. Shared by the editor's save validation and the
 * import path (cue-forge-drt.11) so the two gates cannot drift.
 */
export function isBuiltinPresetName(name: string): boolean {
  return BUILTIN_NAME_SET.has(name.trim().toLowerCase());
}
